import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Avatar, Stack } from '@mui/material';
import { EmployeeToBusiness, LoadedUser, ModalData } from '../../interfaces';
import { createModalData } from '../modal/employeeModal';
import {
  getPayoutText,
  getSelectedRolesFromEmployee,
  getTeamMemberStatus,
  TeamMemberStatus,
} from '../../helpers/employees';
import { HeaderCells } from '../../types/ui';
import { getRoleLabel } from '../form/artistForm';
import { Offboarding } from '../../types/offboardings';

export const headerCells = [
  { id: 'Name', label: 'Name' },
  { id: 'Job', label: 'Job' },
  { id: 'Status', label: 'Status' },
  { id: 'Payee', label: 'Payee' },
  { id: 'View Employee', label: '' },
] as const satisfies HeaderCells;

const STATUS_LABEL: Record<TeamMemberStatus, string> = {
  OFFBOARDING: 'Offboarding…',
  OFFBOARDING_SCHEDULED: 'Offboarding scheduled',
  INVITED: 'Invited',
  ACTIVE: 'Active',
};

// Function to create a table row from an employee data
export function createRow({
  currentUser,
  employee,
  handleClick,
  offboarding,
}: {
  currentUser: LoadedUser;
  employee: EmployeeToBusiness;
  handleClick: (newModalData: ModalData, employee: EmployeeToBusiness) => void;
  offboarding?: Offboarding | null;
}) {
  const newModalData = createModalData(currentUser, employee) as ModalData;

  const statusText = STATUS_LABEL[getTeamMemberStatus(employee, offboarding)];

  const cleanedRole = employee.user
    ? getSelectedRolesFromEmployee(employee.user.role, employee)
        .map(getRoleLabel)
        .join(', ')
    : '-';

  const names = (
    employee.user?.firstName
      ? [employee.user?.firstName, employee.user?.lastName]
      : [employee?.displayName]
  ).filter(Boolean) as string[];
  const initials = names.map(name => name.charAt(0).toUpperCase()).join('');

  const payoutText = getPayoutText(employee);

  const row = {
    rowId: employee.employeeId,
    cells: [
      <Stack direction="row" gap={2} alignItems="center">
        <Avatar
          sx={{
            width: 32,
            height: 32,
            backgroundColor: employee.color,
            boxSizing: 'border-box',
            p: 1,
            fontSize: theme => theme.typography.body2.fontSize,
          }}>
          {initials}
        </Avatar>
        <Typography variant="body1">
          {employee.user?.firstName} {employee.user?.lastName}
        </Typography>
      </Stack>,
      <Typography variant="body1">{cleanedRole}</Typography>,
      <Typography variant="body1">{statusText}</Typography>,
      <Typography variant="body1">{payoutText}</Typography>,
      <Button
        onClick={() => handleClick(newModalData, employee)}
        variant="outlined"
        className="table-button">
        View Employee
      </Button>,
    ],
  };

  return row;
}
